import { lazy } from "react";
import Loadable from "../utils/Loadable";
import Home from "../pages/Home";

const ForgotPassword = Loadable(lazy(() => import("../pages/auth/ForgotPassword")));
const Login = Loadable(lazy(() => import("../pages/auth/Login")));
const Register = Loadable(lazy(() => import("../pages/auth/Register")));
const Verify = Loadable(lazy(() => import("../pages/auth/Verify")));
const ListTop = Loadable(lazy(() => import("../pages/list/ListTop")));
const RadList = Loadable(lazy(() => import("../pages/list/RadList")));
const RadMiniList = Loadable(lazy(() => import("../pages/list/RadMiniList")));
const CharList = Loadable(lazy(() => import("../pages/list/CharList")));
const McwList = Loadable(lazy(() => import("../pages/list/McwList")));
const HskList = Loadable(lazy(() => import("../pages/list/HskList")));
const CiList = Loadable(lazy(() => import("../pages/list/CiList")));
const DomList = Loadable(lazy(() => import("../pages/list/DomList")));
const DuoList = Loadable(lazy(() => import("../pages/list/DuoList")));
const TonalPairList = Loadable(lazy(() => import("../pages/list/TonalPairList")));
const PhraseList = Loadable(lazy(() => import("../pages/list/PhraseList")));
const RadStudy = Loadable(lazy(() => import("../pages/study/RadStudy")));
const Study = Loadable(lazy(() => import("../pages/study/Study")));
const CiStudy = Loadable(lazy(() => import("../pages/study/CiStudy")));
const DuoStudy = Loadable(lazy(() => import("../pages/study/DuoStudy")));
const DomStudy = Loadable(lazy(() => import("../pages/study/DomStudy")));
const ParonymStudy = Loadable(lazy(() => import("../pages/quiz/ParonymQuiz")));
const ParamorphStudy = Loadable(lazy(() => import("../pages/study/ParamorphStudy")));
const PolyphoneStudy = Loadable(lazy(() => import("../pages/study/PolyphoneStudy")));
const Hsk2Study = Loadable(lazy(() => import("../pages/study/Hsk2Study")));
const Hsk3Study = Loadable(lazy(() => import("../pages/study/Hsk3Study")));
const Parts = Loadable(lazy(() => import("../pages/quiz/Parts"))); // Test for dynamic accordion
const RadQuiz = Loadable(lazy(() => import("../pages/quiz/RadQuiz")));
const CiQuiz = Loadable(lazy(() => import("../pages/quiz/CiQuiz")));
const DomQuiz = Loadable(lazy(() => import("../pages/quiz/DomQuiz")));
const DuoQuiz = Loadable(lazy(() => import("../pages/quiz/DuoQuiz")));
const ParonymQuiz = Loadable(lazy(() => import("../pages/quiz/ParonymQuiz")));
const ParamorphQuiz = Loadable(lazy(() => import("../pages/quiz/ParamorphQuiz")));
const Hsk2Quiz = Loadable(lazy(() => import("../pages/quiz/Hsk2Quiz")));
const Hsk3Quiz = Loadable(lazy(() => import("../pages/quiz/Hsk3Quiz")));
const PhraseQuiz = Loadable(lazy(() => import("../pages/quiz/PhraseQuiz")));
const UserTop = Loadable(lazy(() => import("../pages/user/UserTop")));
const UserScore = Loadable(lazy(() => import("../pages/user/UserScore")));
const UserFlag = Loadable(lazy(() => import("../pages/user/UserFlag")));
const UserPriority = Loadable(lazy(() => import("../pages/user/UserPriority")));
const UserDiscuss = Loadable(lazy(() => import("../pages/user/UserDiscuss")));
const UserSettings = Loadable(lazy(() => import("../pages/user/UserSettings")));
const UserSubscription = Loadable(lazy(() => import("../pages/user/UserSubscription")));
const PwReset = Loadable(lazy(() => import("../pages/user/PwReset")));
const ResourcesTop = Loadable(lazy(() => import("../pages/resources/ResourcesTop")));
const Faq = Loadable(lazy(() => import("../pages/resources/Faq")));
const ChangeLog = Loadable(lazy(() => import("../pages/resources/ChangeLog")));
const Pronunciation = Loadable(lazy(() => import("../pages/resources/Pronunciation")));
const CharStats = Loadable(lazy(() => import("../pages/resources/CharStats")));
const PrivacyPolicy = Loadable(lazy(() => import("../pages/footer/PrivacyPolicy")));
const TermsOfService = Loadable(lazy(() => import("../pages/footer/TermsOfService")));
const About = Loadable(lazy(() => import("../pages/footer/About")));
const Contact = Loadable(lazy(() => import("../pages/footer/Contact")));
const UserBillofRights = Loadable(lazy(() => import("../pages/footer/UserBillofRights")));

// path appears in the URL, name appears in the menu, parent determines the menu hierarchy

export const nav = [
  { path: "/", name: "Home", parent: "none", isPrivate: false, element: <Home /> },
  { path: "/login", name: "Login", parent: "none", isPrivate: false, element: <Login /> },
  { path: "/register", name: "Register", parent: "none", isPrivate: false, element: <Register /> },
  { path: "/verify", name: "Verify", parent: "none", isPrivate: false, element: <Verify /> },
  {
    path: "/forgotpassword",
    name: "Forgot Password",
    parent: "none",
    isPrivate: false,
    element: <ForgotPassword />,
  },
  {
    path: "/privacy",
    name: "Privacy Policy",
    parent: "Footer",
    isPrivate: false,
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms",
    name: "Terms of Service",
    parent: "Footer",
    isPrivate: false,
    element: <TermsOfService />,
  },
  {
    path: "/billofrights",
    name: "User Bill of Rights",
    parent: "Footer",
    isPrivate: false,
    element: <UserBillofRights />,
  },
  { path: "/list/", name: "List", parent: "top", isPrivate: true, element: <ListTop /> },
  {
    path: "/list/radical",
    name: "Radicals",
    parent: "List",
    isPrivate: true,
    element: <RadList />,
  },
  {
    path: "/list/radical-mini",
    name: "Radical Minis",
    parent: "none",
    isPrivate: true,
    element: <RadMiniList />,
  },
  {
    path: "/list/characters",
    name: "Characters",
    parent: "List",
    isPrivate: true,
    element: <CharList />,
  },
  { path: "/list/mcw", name: "MCW", parent: "List", isPrivate: true, element: <McwList /> },
  { path: "/list/hsk", name: "HSK", parent: "List", isPrivate: true, element: <HskList /> },
  {
    path: "/list/confucius",
    name: "Confucius",
    parent: "List",
    isPrivate: true,
    element: <CiList />,
  },
  { path: "/list/domino", name: "Domino", parent: "List", isPrivate: true, element: <DomList /> },
  {
    path: "/list/duolingo",
    name: "Duolingo",
    parent: "List",
    isPrivate: true,
    element: <DuoList />,
  },
  {
    path: "/list/phrase",
    name: "Phrase",
    parent: "List",
    isPrivate: true,
    element: <PhraseList />,
  },
  {
    path: "/list/tonalpairs",
    name: "Tonal Pairs",
    parent: "List",
    isPrivate: true,
    element: <TonalPairList />,
  },
  {
    path: "/study/radical",
    name: "Radicals",
    parent: "Study",
    isPrivate: true,
    element: <RadStudy />,
  },
  { path: "/study", name: "Domino", parent: "none", isPrivate: true, element: <Study /> },
  {
    path: "/study/confucius",
    name: "Confucius",
    parent: "Study",
    isPrivate: true,
    element: <CiStudy />,
  },
  {
    path: "/study/duolingo",
    name: "Duolingo",
    parent: "Study",
    isPrivate: true,
    element: <DuoStudy />,
  },
  {
    path: "/study/domino",
    name: "Domino",
    parent: "Study",
    isPrivate: true,
    element: <DomStudy />,
  },
  {
    path: "/study/paronym",
    name: "Paronyms",
    parent: "Study",
    isPrivate: true,
    element: <ParonymStudy />,
  },
  {
    path: "/study/paramorph",
    name: "Paramorphs",
    parent: "Study",
    isPrivate: true,
    element: <ParamorphStudy />,
  },
  {
    path: "/study/polyphone",
    name: "Polyphones",
    parent: "Study",
    isPrivate: true,
    element: <PolyphoneStudy />,
  },
  { path: "/study/hsk2", name: "HSK 2", parent: "Study", isPrivate: true, element: <Hsk2Study /> },
  { path: "/study/hsk3", name: "HSK 3", parent: "Study", isPrivate: true, element: <Hsk3Study /> },
  { path: "/quiz/parts", name: "Parts", parent: "none", isPrivate: true, element: <Parts /> },
  {
    path: "/quiz/radical",
    name: "Radicals",
    parent: "Quiz",
    isPrivate: true,
    element: <RadQuiz />,
  },
  {
    path: "/quiz/confucius",
    name: "Confucius",
    parent: "Quiz",
    isPrivate: true,
    element: <CiQuiz />,
  },
  { path: "/quiz/domino", name: "Domino", parent: "Quiz", isPrivate: true, element: <DomQuiz /> },
  {
    path: "/quiz/duolingo",
    name: "Duolingo",
    parent: "Quiz",
    isPrivate: true,
    element: <DuoQuiz />,
  },
  {
    path: "/quiz/paronym",
    name: "Paronyms",
    parent: "Quiz",
    isPrivate: true,
    element: <ParonymQuiz />,
  },
  {
    path: "/quiz/paramorph",
    name: "Paramorphs",
    parent: "Quiz",
    isPrivate: true,
    element: <ParamorphQuiz />,
  },
  { path: "/quiz/hsk2", name: "HSK 2", parent: "Quiz", isPrivate: true, element: <Hsk2Quiz /> },
  { path: "/quiz/hsk3", name: "HSK 3", parent: "Quiz", isPrivate: true, element: <Hsk3Quiz /> },
  {
    path: "/quiz/phrase",
    name: "Phrase",
    parent: "Quiz",
    isPrivate: true,
    element: <PhraseQuiz />,
  },
  {
    path: "/resources/",
    name: "Resources",
    parent: "top",
    isPrivate: true,
    element: <ResourcesTop />,
  },
  {
    path: "/resources/pronunciation",
    name: "Pronunciation",
    parent: "Resources",
    isPrivate: true,
    element: <Pronunciation />,
  },
  { path: "/resources/faq", name: "FAQ", parent: "Resources", isPrivate: true, element: <Faq /> },
  {
    path: "/resources/charstats",
    name: "Character Stats",
    parent: "Resources",
    isPrivate: true,
    element: <CharStats />,
  },
  {
    path: "/resources/changelog",
    name: "Change Log",
    parent: "Resources",
    isPrivate: true,
    element: <ChangeLog />,
  },
  { path: "/contact", name: "Contact", parent: "none", isPrivate: false, element: <Contact /> },
  { path: "/about", name: "About", parent: "none", isPrivate: false, element: <About /> },
  { path: "/user/", name: "Stats", parent: "My Content", isPrivate: true, element: <UserTop /> },
  {
    path: "/user/score",
    name: "Scores",
    parent: "My Content",
    isPrivate: true,
    element: <UserScore />,
  },
  {
    path: "/user/flag",
    name: "Flag",
    parent: "My Content",
    isPrivate: true,
    element: <UserFlag />,
  },
  {
    path: "/user/priority",
    name: "Priority",
    parent: "My Content",
    isPrivate: true,
    element: <UserPriority />,
  },
  {
    path: "/user/discuss",
    name: "Discuss",
    parent: "My Content",
    isPrivate: true,
    element: <UserDiscuss />,
  },
  {
    path: "/user/settings",
    name: "Settings",
    parent: "none",
    isPrivate: true,
    element: <UserSettings />,
  },
  {
    path: "/user/pwreset",
    name: "Password Reset",
    parent: "none",
    isPrivate: true,
    element: <PwReset />,
  },
  {
    path: "/user/subscription",
    name: "Subscription",
    parent: "none",
    isPrivate: true,
    element: <UserSubscription />,
  },
];
